import React from 'react';
import { Modal, Button, List, Typography, Divider } from 'antd';
import { TransactionPriceResultDTO, TransactionFeeDTO } from '@/shared/api/model';
import { formatAmount } from "@/components/common/utils/money";

const { Title, Text } = Typography;

interface PriceConfirmationModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    priceResult?: TransactionPriceResultDTO;
    loading?: boolean;
    dark?: boolean;
}

export const PriceConfirmationModal: React.FC<PriceConfirmationModalProps> = ({
                                                                                  open,
                                                                                  onClose,
                                                                                  onConfirm,
                                                                                  priceResult,
                                                                                  loading,
                                                                                  dark
                                                                              }) => {
    if (!priceResult) return null;

    return (
        <Modal
            title="Transaction Pricing Details"
            open={open}
            onCancel={onClose}
            footer={[
                <Button key="back" onClick={onClose}>
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={loading}
                    onClick={onConfirm}
                >
                    Confirm Payment
                </Button>
            ]}
            className={dark ? 'dark-mode' : ''}
        >
            <div className="space-y-4">
                <div>
                    <Title level={5}>Transaction Amount</Title>
                    <Text>{formatAmount(priceResult.transactionAmount || 0)} TZS</Text>
                </div>

                <Divider />

                <div>
                    <Title level={5}>Fees</Title>
                    <List
                        size="small"
                        dataSource={priceResult.fees}
                        renderItem={(fee: TransactionFeeDTO) => (
                            <List.Item>
                                <div className="flex justify-between w-full">
                                    <Text>{fee.description}</Text>
                                    <Text>{formatAmount(fee.amount || 0)} TZS</Text>
                                </div>
                            </List.Item>
                        )}
                    />
                </div>

                {priceResult.adjustments && priceResult.adjustments.length > 0 && (
                    <>
                        <Divider />
                        <div>
                            <Title level={5}>Adjustments</Title>
                            <List
                                size="small"
                                dataSource={priceResult.adjustments}
                                renderItem={(adjustment) => (
                                    <List.Item>
                                        <div className="flex justify-between w-full">
                                            <Text>{adjustment.description}</Text>
                                            <Text>{formatAmount(adjustment.amount || 0)} TZS</Text>
                                        </div>
                                    </List.Item>
                                )}
                            />
                        </div>
                    </>
                )}

                <Divider />

                <div className="bg-gray-50 p-4 rounded-lg dark:bg-gray-800">
                    <div className="flex justify-between">
                        <Title level={4}>Total Amount</Title>
                        <Title level={4}>{formatAmount(priceResult.finalAmount || 0)} TZS</Title>
                    </div>
                </div>
            </div>
        </Modal>
    );
};